import { useQuery } from '@tanstack/react-query';
import type { AgentApiProfitsMonthlyTotals } from '@/types/serializers';
import type { ProfitsSearchParams } from './useFetchProfits';
import { fetchJson } from '@/utils/apiFetch';

const buildQueryParams = (params?: ProfitsSearchParams): string => {
  if (!params) return '';
  const qs: string[] = [];

  if (params.query) qs.push(`query=${encodeURIComponent(params.query)}`);
  if (params.status) qs.push(`status=${encodeURIComponent(params.status)}`);
  if (params.organization_user_id)
    qs.push(`organization_user_id=${encodeURIComponent(params.organization_user_id)}`);
  if (params.company_organization_user_id)
    qs.push(
      `company_organization_user_id=${encodeURIComponent(params.company_organization_user_id)}`
    );
  if (params.candidate_organization_user_id)
    qs.push(
      `candidate_organization_user_id=${encodeURIComponent(params.candidate_organization_user_id)}`
    );
  if (params.company_id) qs.push(`company_id=${encodeURIComponent(params.company_id)}`);
  if (params.team_id) qs.push(`team_id=${encodeURIComponent(params.team_id)}`);
  if (params.entry_date_range?.from)
    qs.push(`entry_date_range[from]=${encodeURIComponent(params.entry_date_range.from)}`);
  if (params.entry_date_range?.to)
    qs.push(`entry_date_range[to]=${encodeURIComponent(params.entry_date_range.to)}`);

  return qs.length > 0 ? `?${qs.join('&')}` : '';
};

export default function useFetchProfitsMonthlyTotals(params?: ProfitsSearchParams) {
  return useQuery({
    queryKey: ['/agent/api/profits/monthly_totals', JSON.stringify(params)],
    queryFn: async () => {
      const queryString = buildQueryParams(params);
      const data = await fetchJson<AgentApiProfitsMonthlyTotals>(
        `/agent/api/profits/monthly_totals.json${queryString}`
      );
      return data;
    },
  });
}
